module.exports = __webpack_public_path__ + "static/media/price_error.9880de9b.svg";